export const CHAT_IG_THEME = {
  page: "bg-background text-text-primary dark:bg-black dark:text-white",
  headerSurface: "bg-surface/95 backdrop-blur-xl dark:bg-black/95",
  border: "border-border dark:border-glass-border-08",
  strongBorder: "border-border-strong dark:border-glass-border-14",
  titleText: "text-text-primary dark:text-white",
  secondaryText: "text-text-secondary dark:text-white/88",
  mutedText: "text-text-tertiary dark:text-white/56",
  tertiaryText: "text-text-tertiary/80 dark:text-white/38",
  accentText: "text-brand",
  accentBg: "bg-brand",
  accentBgSoft: "bg-brand/18",
  accentBgHover: "hover:bg-brand-hover",
  dangerText: "text-error",
  inputBg: "bg-surface-alt dark:bg-[#262626]",
  sheetBg: "bg-surface dark:bg-[#111111]",
  hoverBg: "hover:bg-surface-alt dark:hover:bg-glass-bg-04",
  receivedBubble:
    "bg-surface-alt text-text-primary dark:bg-[#262626] dark:text-white",
  ownBubble:
    "bg-gradient-to-br from-bubble-own-from to-bubble-own-to text-text-inverse dark:text-white",
  softSurface: "bg-surface-alt dark:bg-[#171717]",
  chipSurface: "bg-surface dark:bg-[#1f1f1f]",
  inverseText: "text-text-inverse dark:text-white",
  reactionChip:
    "border-border bg-surface text-text-secondary shadow-sm dark:border-glass-border-12 dark:bg-[#0b0b0e] dark:text-white/72 dark:shadow-[0_8px_22px_rgba(0,0,0,0.34)]",
  reactionChipActive:
    "border-brand/35 bg-brand/10 text-text-primary shadow-sm dark:bg-[#171128] dark:text-white dark:shadow-[0_8px_22px_rgba(0,0,0,0.34)]",
  avatarRing: "border-background dark:border-[#0a0d13]",
} as const;
